<template>
    <v-card class="rounded-xl">
        <v-card-title class="headline primary white--text d-flex justify-space-between align-center">
            <span>Códigos PTI - Cliente: {{ customerTemplate ? customerTemplate.CardName || customerTemplate.CardCode :
                '' }}</span>
            <v-btn icon dark @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
            <s-crud v-if="isReady" ref="gridPtiCodes" title="Detalle de Códigos PTI" add edit remove :config="config"
                :filter="filter" @save="save($event)" @rowSelected="onRowSelected($event)" searchInput height="50dvh">
                <template scope="props">
                    <v-container fluid class="pa-2" v-if="initializeEdit(props.item)">
                        <v-row dense>
                            <!-- Cultivo -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select-definition label="Cultivo" :def="1173" v-model="props.item.TypeCrop"
                                    @change="onCultiveChange($event, props.item)"
                                    @getDataInitial="cropItems = $event" />
                            </v-col>

                            <!-- Variedad -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select-variety full clearable
                                    :cultiveID="props.item.TypeCrop ? Number(props.item.TypeCrop) : 0"
                                    v-model="props.item.VrtID" label="Variedad"
                                    @getDataInitial="varietyItems = $event" />
                            </v-col>

                            <!-- Tipo Cultivo -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select-definition label="Tipo Cultivo" clearable :def="1172"
                                    v-model="props.item.TypeCultive" @getDataInitial="cultiveItems = $event" />
                            </v-col>

                            <!-- Marca Caja -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select class="text-capitalize" clearable autocomplete label="Marca Caja"
                                    :items="uniqueBrands(props.item.TypeCrop)" item-text="Text" item-value="Value"
                                    :value="props.item.Brand === '*' ? null : props.item.Brand"
                                    @change="onChangeBrandName($event, props.item)" placeholder="Seleccionar marca"
                                    id="sBrandNamePti" ref="sBrandNamePti" :disabled="props.item.Brand === '*'" />
                                <!-- <v-checkbox :input-value="props.item.Brand === '*'"
                                    @change="onToggleAllBrands($event, props.item)" label="TODAS LAS MARCAS" dense
                                    hide-details class="mt-1" /> -->
                            </v-col>

                            <!-- Peso Caja -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select class="text-capitalize" clearable autocomplete label="peso caja (KG)"
                                    :items="itemsBoxWeights" item-text="Text" item-value="Value"
                                    :value="props.item.Weighed" @change="onChangeWeight($event, props.item)"
                                    placeholder="Seleccionar peso" id="sBoxWeightPti" ref="sBoxWeightPti" />
                            </v-col>

                            <!-- Calibre -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select-definition :def="1266" label="Calibre" v-model="props.item.TypeCaliber"
                                    clearable @getDataInitial="sizeItems = $event" />
                            </v-col>

                            <!-- Hidden select definition to fetch GTIN 14 items in background -->
                            <div style="display: none;">
                                <s-select-definition :def="1722" @getDataInitial="gtinItems = $event" />
                            </div>

                            <!-- GTIN 14 -->
                            <v-col cols="12" sm="6" md="3">
                                <s-select autocomplete label="Código GTIN 14" :items="gtinItemsMapped"
                                    item-text="SelectionText" item-value="DedValue" :value="props.item.GtinID"
                                    @change="onGtinChange($event, props.item)" placeholder="Seleccionar GTIN 14"
                                    id="sGTIN14Pti" ref="sGTIN14Pti" clearable :slotTmp="true">
                                    <template v-slot:item="{ item }">
                                        <span v-html="item.DisplayText"></span>
                                    </template>
                                </s-select>
                            </v-col>

                            <v-col cols="12" sm="6" md="3">
                                <s-select-definition clearable searchable :def="1723" label="Código PLU Sticker"
                                    v-model="props.item.PluID" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6">
                                <v-checkbox :input-value="props.item.Brand === '*'"
                                    @change="onToggleAllBrands($event, props.item)"
                                    label="APLICAR PARA TODAS LAS MARCAS" dense hide-details class="pa-0" />
                                <!-- <v-checkbox :input-value="props.item.TypePrintPTI === 2"
                                    @change="onToggleTypePrintPTI($event, props.item)" label="MARCAR COMO STICKER" dense
                                    hide-details class="pa-0" /> -->
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </s-crud>
        </v-card-text>
    </v-card>
</template>

<script>
import _sPrfCustomerTemplatePtiService from "@/services/FreshProduction/PrfCustomerTemplatePtiService";
import _sPackingService from "@/services/FreshProduction/PackingService";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety.vue";

export default {
    name: "PrfCustomerTemplatePtiModal",
    components: { SSelectVariety },
    props: {
        ctmpId: {
            type: [Number, String],
            required: true
        },
        customerTemplate: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            cultiveItems: [],
            varietyItems: [],
            cropItems: [],
            sizeItems: [],
            gtinItems: [],
            itemsMaterialBrands: [],
            itemsBoxWeights: [],
            filter: {
                CtmpID: this.ctmpId
            },
            config: {
                model: {
                    CtmpdID: "ID",
                    CtmpID: "int",
                    TypeCultive: "int",
                    VrtID: "int",
                    TypeCrop: "int",
                    Brand: "string",
                    Weighed: "number",
                    TypeCaliber: "int",
                    GtinID: "int",
                    PluID: "int",
                    SecStatus: "int"
                },
                service: _sPrfCustomerTemplatePtiService,
                headers: [
                    { text: "ID", value: "CtmpdID", width: 50 },
                    { text: "Cultivo", value: "TypeCropName" },
                    { text: "Variedad", value: "VrtName" },
                    { text: "Tipo Cultivo", value: "TypeCultiveName", align: 'center' },
                    { text: "Marca", value: "Brand", align: 'center' },
                    { text: "Peso (KG)", value: "Weighed", align: 'center' },
                    { text: "Calibre", value: "TypeCaliberName", align: 'center' },
                    { text: "Código GTIN 14", value: "GtinName", align: 'center' },
                    { text: "PLU Caja", value: "GeneralPlu", align: 'center' },
                    { text: "Código PLU Sticker", value: "CodePluSticker", align: 'center' },
                    { text: "PLU Sticker", value: "PluSticker", align: 'center' },
                    { text: "Abrev PLU Sticker", value: "AbreviatureCodePluSticker", align: 'center' },
                    // { text: "Estado", value: "SecStatus", width: 80 }
                ]
            }
        };
    },
    computed: {
        isReady() {
            return this.ctmpId !== null && this.ctmpId !== undefined && this.ctmpId !== '';
        },
        gtinItemsMapped() {
            return (this.gtinItems || []).map(item => {
                return {
                    ...item,
                    SelectionText: item.DedHelper ? `${item.DedDescription} PLU: ${item.DedHelper}` : item.DedDescription,
                    DisplayText: item.DedHelper ? `${item.DedDescription} <b>PLU: ${item.DedHelper}</b>` : item.DedDescription
                };
            });
        }
    },
    watch: {
        ctmpId(newId) {
            this.filter.CtmpID = newId;
            if (this.$refs.gridPtiCodes) {
                this.$refs.gridPtiCodes.refresh();
            }
        },
        itemsMaterialBrands(newVal) {
            if (this.$refs.gridPtiCodes) {
                const selected = this.$refs.gridPtiCodes.selected;
                if (selected && selected.length > 0) {
                    this.onRowSelected(selected);
                }
                if (this.$refs.gridPtiCodes.showForm) {
                    const row = this.$refs.gridPtiCodes.row;
                    if (row) {
                        if (row.Brand === '*') {
                            this.loadAllUniqueWeights(row.TypeCrop);
                        } else if (row.Brand) {
                            const weights = [];
                            const seen = new Set();
                            const matchingItems = (newVal || []).filter(x => x.Brand === row.Brand);

                            matchingItems.forEach(x => {
                                if (x.Weighed != null) {
                                    const weightStr = String(x.Weighed);
                                    if (!seen.has(weightStr)) {
                                        seen.add(weightStr);
                                        weights.push({
                                            Text: x.Weighed + ' ' + x.UnitMeasurement,
                                            Value: x.Weighed
                                        });
                                    }
                                }
                            });
                            this.itemsBoxWeights = weights;
                        }
                    }
                }
            }
        }
    },
    created() {
        this.Initialize();
    },
    mounted() {
        this.$watch(
            () => this.$refs.gridPtiCodes && this.$refs.gridPtiCodes.showForm,
            (newVal) => {
                if (newVal) {
                    const row = this.$refs.gridPtiCodes.row;
                    if (row) {
                        this.$set(row, '_lastTypeCrop', row.TypeCrop);
                        this.$set(row, '_lastBrand', row.Brand);
                        this.$set(row, '_lastWeighed', row.Weighed);
                        this.$set(row, '_lastGtin', row.GtinID);
                        this.$set(row, '_lastPlu', row.PluID);
                        if (row.Brand === '*') {
                            this.loadAllUniqueWeights(row.TypeCrop);
                        } else if (row.Brand) {
                            const weights = [];
                            const seen = new Set();
                            const matchingItems = (this.itemsMaterialBrands || []).filter(x => x.Brand === row.Brand);

                            matchingItems.forEach(x => {
                                if (x.Weighed != null) {
                                    const weightStr = String(x.Weighed);
                                    if (!seen.has(weightStr)) {
                                        seen.add(weightStr);
                                        weights.push({
                                            Text: x.Weighed + ' ' + x.UnitMeasurement,
                                            Value: x.Weighed
                                        });
                                    }
                                }
                            });
                            this.itemsBoxWeights = weights;
                        }
                    }
                }
            }
        );
    },
    methods: {
        initializeEdit(item) {
            if (item && item._lastTypeCrop === undefined) {
                this.$set(item, '_lastTypeCrop', item.TypeCrop);
                this.$set(item, '_lastBrand', item.Brand);
                this.$set(item, '_lastWeighed', item.Weighed);
                this.$set(item, '_lastGtin', item.GtinID);
                this.$set(item, '_lastPlu', item.PluID);
            }
            return true;
        },
        Initialize() {
            this.loadMaterialBrands();
        },
        loadMaterialBrands() {
            const filter = {
                Search: '',
                TypeCrop: null,
                VrtID: null,
                TypeCultive: null,
                UwoStatus: 1 // @PackingLineStatus: ACTIVOS
            }
            _sPackingService.listMaterialBrand(filter, this.$fun.getUserID()).then(r => {
                this.itemsMaterialBrands = r.status == 200 ? r.data : [];
                console.log("listMaterialBrand modal", r.data);
            }).catch(err => {
                console.error("Error al cargar marcas de material en modal:", err);
            });
        },
        uniqueBrands(TypeCrop) {
            if (!TypeCrop) return [];
            const list = [];
            const seen = new Set();
            (this.itemsMaterialBrands || []).forEach(x => {
                if (x.CropID == TypeCrop && x.Brand && !seen.has(x.Brand)) {
                    seen.add(x.Brand);
                    list.push({
                        Text: x.Brand,
                        Value: x.Brand
                    });
                }
            });
            return list;
        },
        onCultiveChange(cultiveID, item) {
            // Guard against s-select-generic emitting the list of items on load
            const actualCropID = (Array.isArray(cultiveID) || (cultiveID && typeof cultiveID === 'object')) ? item.TypeCrop : cultiveID;
            console.log("onCultiveChange modal:", actualCropID);
            if (item._lastTypeCrop === undefined) {
                this.$set(item, '_lastTypeCrop', actualCropID);
                return;
            }
            if (item._lastTypeCrop === actualCropID) {
                return;
            }
            item._lastTypeCrop = actualCropID;
            if (actualCropID) {
                item.Brand = null;
                item.Weighed = null;
                item.UnitMeasurement = null;
                item.TypeBox = null;
                item.VrtID = null;
                this.itemsBoxWeights = [];
            } else {
                item.Brand = null;
                item.Weighed = null;
                item.UnitMeasurement = null;
                item.TypeBox = null;
                item.VrtID = null;
                this.itemsBoxWeights = [];
            }
        },
        onChangeBrandName(brandName, item) {
            const actualBrandName = (brandName && typeof brandName === 'object' && brandName.target) ? item.Brand : brandName;
            console.log("onChangeBrandName modal:", actualBrandName);
            if (item.Brand === '*') {
                return;
            }
            if (item._lastBrand === undefined) {
                this.$set(item, '_lastBrand', item.Brand);
                return;
            }
            if (item._lastBrand === actualBrandName) {
                return;
            }
            item._lastBrand = actualBrandName;
            if (!actualBrandName) {
                this.itemsBoxWeights = [];
                item.Brand = null;
                item.Weighed = null;
                item.UnitMeasurement = null;
                item.TypeBox = null;
                return;
            }
            item.Brand = actualBrandName;

            const weights = [];
            const seen = new Set();
            const matchingItems = (this.itemsMaterialBrands || []).filter(x => x.Brand === actualBrandName);

            matchingItems.forEach(x => {
                if (x.Weighed != null) {
                    const weightStr = String(x.Weighed);
                    if (!seen.has(weightStr)) {
                        seen.add(weightStr);
                        weights.push({
                            Text: x.Weighed + ' ' + x.UnitMeasurement,
                            Value: x.Weighed
                        });
                    }
                }
            });
            this.itemsBoxWeights = weights;
            item.TypeBox = matchingItems.map(x => x.TypeBox).filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(', ');

            item.Weighed = null;
            item.UnitMeasurement = null;
        },
        onToggleAllBrands(checked, item) {
            console.log("onToggleAllBrands:", checked, "current Brand:", item.Brand);
            if (checked) {
                if (item.Brand === '*') {
                    return;
                }
                item.Brand = '*';
                this.$set(item, '_lastBrand', '*');
                this.loadAllUniqueWeights(item.TypeCrop);
                item.Weighed = null;
                item.UnitMeasurement = null;
                item.TypeBox = null;
            } else {
                if (item.Brand !== '*') {
                    return;
                }
                item.Brand = null;
                this.$set(item, '_lastBrand', null);
                this.itemsBoxWeights = [];
                item.Weighed = null;
                item.UnitMeasurement = null;
                item.TypeBox = null;
            }
        },
        onToggleTypePrintPTI(checked, item) {
            if (checked) {
                if (item.TypePrintPTI === 2) {
                    return;
                }
                item.TypePrintPTI = 2;
            } else {
                if (item.TypePrintPTI !== 2) {
                    return;
                }
                item.TypePrintPTI = 1;
            }
        },
        loadAllUniqueWeights(TypeCrop) {
            const weights = [];
            const seen = new Set();
            (this.itemsMaterialBrands || []).forEach(x => {
                if (TypeCrop && x.CropID != TypeCrop) return;
                if (x.Weighed != null) {
                    const weightStr = String(x.Weighed);
                    if (!seen.has(weightStr)) {
                        seen.add(weightStr);
                        weights.push({
                            Text: x.Weighed + ' ' + (x.UnitMeasurement || ''),
                            Value: x.Weighed
                        });
                    }
                }
            });
            this.itemsBoxWeights = weights;
        },
        onChangeWeight(weight, item) {
            const actualWeight = (weight && typeof weight === 'object' && weight.target) ? item.Weighed : weight;
            console.log("onChangeWeight modal:", actualWeight);
            if (item._lastWeighed === undefined) {
                this.$set(item, '_lastWeighed', item.Weighed);
                return;
            }
            if (item._lastWeighed === actualWeight) {
                return;
            }
            item._lastWeighed = actualWeight;

            if (actualWeight == null) {
                item.Weighed = null;
                item.UnitMeasurement = null;
                return;
            }
            item.Weighed = actualWeight;
            const matchingItem = (this.itemsMaterialBrands || []).find(x => {
                if (item.Brand === '*') {
                    return (!item.TypeCrop || x.CropID == item.TypeCrop) && x.Weighed == actualWeight;
                } else {
                    return x.Brand === item.Brand && x.Weighed == actualWeight;
                }
            });
            if (matchingItem) {
                item.UnitMeasurement = matchingItem.UnitMeasurement;
                item.TypeBox = matchingItem.TypeBox;
            }
        },
        onGtinChange(gtinID, item) {
            const actualGtinID = (gtinID && typeof gtinID === 'object' && gtinID.target) ? item.GtinID : gtinID;
            if (item._lastGtin === undefined) {
                this.$set(item, '_lastGtin', item.GtinID);
                return;
            }
            if (item._lastGtin === actualGtinID) {
                return;
            }
            item._lastGtin = actualGtinID;

            item.GtinID = actualGtinID;
            if (!actualGtinID) {
                item.PluCode = '';
                return;
            }
            const found = (this.gtinItems || []).find(x => String(x.DedValue) === String(actualGtinID));
            if (found) {
                item.PluCode = found.DedHelper || '';
            }
        },
        onRowSelected(item) {
            const target = Array.isArray(item) ? item[0] : item;
            if (target) {
                this.$set(target, '_lastTypeCrop', target.TypeCrop);
                this.$set(target, '_lastBrand', target.Brand);
                this.$set(target, '_lastWeighed', target.Weighed);
                this.$set(target, '_lastGtin', target.GtinID);
                this.$set(target, '_lastPlu', target.PluID);
                const brandName = target.Brand;
                if (brandName == '*') {
                    this.loadAllUniqueWeights(target.TypeCrop);
                } else {
                    const weights = [];
                    const seen = new Set();
                    const matchingItems = (this.itemsMaterialBrands || []).filter(x => x.Brand === brandName);

                    matchingItems.forEach(x => {
                        if (x.Weighed != null) {
                            const weightStr = String(x.Weighed);
                            if (!seen.has(weightStr)) {
                                seen.add(weightStr);
                                weights.push({
                                    Text: x.Weighed + ' ' + x.UnitMeasurement,
                                    Value: x.Weighed
                                });
                            }
                        }
                    });
                    this.itemsBoxWeights = weights;
                }
            } else {
                this.itemsBoxWeights = [];
            }
        },
        save(item) {
            console.log(JSON.parse(JSON.stringify(item)))
            // if (item.IsAllBrands) {
            //     item.Brand = '*';
            // }

            if (!item.TypeCrop) {
                this.$fun.alert("Debe seleccionar un Cultivo.", "warning");
                return;
            }
            if (!item.Brand) {
                this.$fun.alert("Debe seleccionar una Marca Caja.", "warning");
                return;
            }
            if (!item.Weighed) {
                this.$fun.alert("Debe seleccionar un Peso Caja.", "warning");
                return;
            }
            if (!item.TypeCaliber) {
                this.$fun.alert("Debe seleccionar un Calibre.", "warning");
                return;
            }
            if (!item.GtinID) {
                this.$fun.alert("Debe seleccionar un GTIN 14.", "warning");
                return;
            }

            // Get descriptions for each selected value to keep local UI names in sync
            const cropDesc = (this.cropItems || []).find(x => x.DedValue == item.TypeCrop)?.DedDescription || '';
            const varietyDesc = (this.varietyItems || []).find(x => x.VrtID == item.VrtID)?.VrtDescription || '';
            const cultiveDesc = (this.cultiveItems || []).find(x => x.DedValue == item.TypeCultive)?.DedDescription || '';
            const sizeDesc = (this.sizeItems || []).find(x => x.DedValue == item.TypeCaliber)?.DedDescription || '';
            const foundGtin = (this.gtinItems || []).find(x => String(x.DedValue) === String(item.GtinID));
            const gtinDesc = foundGtin ? foundGtin.DedDescription : '';

            item.TypeCropName = cropDesc;
            item.VrtName = varietyDesc;
            item.TypeCultiveName = cultiveDesc;
            item.TypeCaliberName = sizeDesc;
            item.GtinName = gtinDesc;
            // item.WeighedName = item.Weighed ? `${item.Weighed} KG` : '';

            item.CtmpID = this.ctmpId;
            item.SecStatus = 1;
            item.UsrCreateID = this.$fun.getUserID()

            console.log("Save")
            console.log(JSON.parse(JSON.stringify(item)));
            item.save();
        }
    }
};
</script>

<style scoped></style>
